import { render } from "./RelatedProductsList.vue?vue&type=template&id=2eca8d5b&scoped=true"
import script from "./RelatedProductsList.vue?vue&type=script&lang=js"
export * from "./RelatedProductsList.vue?vue&type=script&lang=js"

import "./RelatedProductsList.vue?vue&type=style&index=0&id=2eca8d5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eca8d5b"]])

export default __exports__